export { CheckingRuleList } from './list'



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/checking-rules/index.js